class GoodsSwiper {
  constructor(el,opt){
    this.el = el;
    if(document.querySelector('.js-goods-swiper')){
      this.event()
    }
  }
  event(){
    const swiperEle = '.js-goods-swiper';
    new Swiper(swiperEle,{
      loop: true,
      spaceBetween: 2,
      navigation: {
        nextEl: '.js-goods-swiper__next',
        prevEl: '.js-goods-swiper__prev',
      },
      pagination: {
        el: '.js-goods-swiper__pagination',
        type: 'bullets',
        clickable: true
      }
    })
  }
}
